import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { TranslateService } from '../../../../core/services/translate-service';
import { MatTableExporterDirective } from 'mat-table-exporter';
import * as moment from 'moment';
import { ResizeEvent } from 'angular-resizable-element';
declare var jQuery: any;

@Component({
	selector: 'app-catalog',
	templateUrl: './catalog.component.html',
	styleUrls: ['./catalog.component.scss'],
})
export class CatalogComponent implements OnInit {
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild(MatTableExporterDirective, { static: true })
	exporter: MatTableExporterDirective;
	@Input() captionbtnAdd: string = "";
  	@Input() columns: Array<string>;
	@Input() data: any;
	@Input() hiddenAdd: any;
  	@Input() labelColors: boolean = false;
  	@Input() hideFilter: boolean = false;
	@Input() station: any;
	@Output() buttonAdd = new EventEmitter<any>();
	@Output() buttonEdit = new EventEmitter<any>();
  	@Output() buttonView = new EventEmitter<any>();
  	@Output() buttonApprove = new EventEmitter<any>();
  	@Output() buttonReject = new EventEmitter<any>();
  	@Output() buttonRedirectToSubcontracting = new EventEmitter<any>();
	@Output() buttonAssign = new EventEmitter<any>();
	@Output() buttonExport = new EventEmitter<any>();
	@Input() exposeExportEvent: boolean = false;
	@Input() fileName: string = 'Archivo';
  	@Input() hideButtonAdd: boolean = false;
  	@Input() hideButtonApprove: boolean = true;
  	@Input() hideButtonReject: boolean = true;
  	@Input() hideButtonRedirectSubcontrating: boolean = true;
	@Input() hideButtonEdit: boolean = false;
	@Output() buttonChangeStatus = new EventEmitter<any>();
	@Output() buttonChangeStatusDc3 = new EventEmitter<any>();
	@Output() buttonChangeStatusCS = new EventEmitter<any>();
	@Output() buttonChangeStatusCriticalWork = new EventEmitter<any>();
	@Output() buttonChangeStatusRequiredNDA = new EventEmitter<any>();
  	@Output() buttonDisable = new EventEmitter<any>();
  	@Output() buttonShowApprovalHistory = new EventEmitter<any>();
	selectedRow: any;
	loading = false;

  	bucketS3Property: string = '';

	constructor(
		private toastr: ToastrService,
		private notificationService: NotificationService,
    	private translateService: TranslateService
	) {}

	ngOnInit() {
		this.loading = false;
		jQuery('.btnReload').click(function () {
			this.loading = false;
		});
	}

	ngOnChanges() {
		if (this.data != undefined) {
			this.data = new MatTableDataSource<any>(this.data);
			this.data.paginator = this.paginator;
			this.data.sort = this.sort;
			this.data.paginator.page.subscribe((pageEvent: PageEvent) => {
				this.OnPaginateChange();
			});
		}
  	}

	Edit(row: any) {
		this.selectedRow = row;
		if (this.selectedRow == null || this.selectedRow == undefined) {
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Error',
				message: this.translateService.data.TABLE.SELECT_ROW,
				shown: true,
			});
			return;
		}
		this.buttonEdit.emit(this.selectedRow);
	}

	View(row: any) {
		this.selectedRow = row;
		if (this.selectedRow == null || this.selectedRow == undefined) {
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Error',
				message: this.translateService.data.TABLE.SELECT_ROW,
				shown: true,
			});
			return;
		}
		this.buttonView.emit(this.selectedRow);
	}

  	Cancel(row: any) {
  	}

	Assign(row: any) {
		this.selectedRow = row;
		if (this.selectedRow == null || this.selectedRow == undefined) {
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Error',
				message: this.translateService.data.TABLE.SELECT_ROW,
				shown: true,
			});
			return;
		}
		this.buttonAssign.emit(this.selectedRow);
	}

	Add() {
		this.buttonAdd.emit();
	}

	Highlight(row: any) {
		if (row == undefined || row == null) {
			this.toastr.error('GENERAL.SELECTROW');
		} else {
			this.selectedRow = row;
		}
	}

	ApplyFilter(filterValue: string) {
		filterValue = filterValue.trim(); // Remove whitespace
		filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
		this.data.filter = filterValue;
	}

	IsBoolean(data: any): boolean {
		return typeof data === 'boolean';
	}

	IsDate(data: any): boolean {
		if (data != null) {
			let noSpace = data.toString().replace(/\s/g, '');
			if (noSpace.length < 3) {
				return false;
			}
			if (data.length > 11 && data[10] == 'T')
				return Date.parse(noSpace) > 0;
			return false;
		}
	}

	Export(row: any): void {
		this.selectedRow = row;
		if (!this.exposeExportEvent) {
			this.exporter.exportTable('xlsx', {
				fileName: this.fileName,
				sheet: 'Hoja 1',
				Props: {
					Author: 'Jabil',
				},
			});
		} else this.buttonExport.emit();
	}

	OnResizeEnd(event: ResizeEvent, columnName): void {
		if (event.edges.right) {
			const cssValue = event.rectangle.width + 'px';
			const columnElts = document.getElementsByClassName(
				'mat-column-' + columnName,
			);
			for (let i = 0; i < columnElts.length; i++) {
				const currentEl = columnElts[i] as HTMLDivElement;
				currentEl.style.width = cssValue;
			}
		}
	}

	OnPaginateChange() {
		this.columns.forEach((column) => {
			const columnElts = document.getElementsByClassName(
				'mat-column-' + column,
			);
			if ((<HTMLDivElement>columnElts[0]).style.width.length > 0) {
				for (let i = 1; i < columnElts.length; i++) {
					const currentEl = columnElts[i] as HTMLDivElement;
					currentEl.style.width = (<HTMLDivElement>(
						columnElts[0]
					)).style.width;
				}
			}
		});
	}

	ChangeStatus(row: any) {
		this.selectedRow = row;
		if (this.selectedRow == null || this.selectedRow == undefined) {
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Error',
				message: this.translateService.data.TABLE.SELECT_ROW,
				shown: true,
			});
			return;
		}
		this.buttonChangeStatus.emit(this.selectedRow);
	}

	ChangeStatusDc3(row: any) {
		this.selectedRow = row;
		if (this.selectedRow == null || this.selectedRow == undefined) {
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Error',
				message: this.translateService.data.TABLE.SELECT_ROW,
				shown: true,
			});
			return;
		}
		this.buttonChangeStatusDc3.emit(this.selectedRow);
	}

	ChangeStatusCS(row: any) {
		this.selectedRow = row;
		if (this.selectedRow == null || this.selectedRow == undefined) {
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Error',
				message: this.translateService.data.TABLE.SELECT_ROW,
				shown: true,
			});
			return;
		}
		this.buttonChangeStatusCS.emit(this.selectedRow);
	}

	ChangeStatusCriticalWork(row: any) {
		this.selectedRow = row;
		if (this.selectedRow == null || this.selectedRow == undefined) {
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Error',
				message: this.translateService.data.TABLE.SELECT_ROW,
				shown: true,
			});
			return;
		}
		this.buttonChangeStatusCriticalWork.emit(this.selectedRow);
	}

	ChangeStatusRequiredNDA(row: any) {
		this.selectedRow = row;
		if (this.selectedRow == null || this.selectedRow == undefined) {
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Error',
				message: this.translateService.data.TABLE.SELECT_ROW,
				shown: true,
			});
			return;
		}
		this.buttonChangeStatusRequiredNDA.emit(this.selectedRow);
	}

	Disable(row: any) {
		this.selectedRow = row;
		if (this.selectedRow == null || this.selectedRow == undefined) {
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Error',
				message: this.translateService.data.TABLE.SELECT_ROW,
				shown: true,
			});
			return;
		}
		this.buttonDisable.emit(this.selectedRow);
	}

	SortData($event) {
		const sortId = $event.active;
		const sortDirection = $event.direction;
		if ('asc' == sortDirection) {
			this.data.data = this.data.data
				.slice()
				.sort((a, b) =>
					a[sortId] > b[sortId] ? -1 : a[sortId] < b[sortId] ? 1 : 0,
				);
		} else {
			this.SortDescDirection(sortId);
		}
		this.OnPaginateChange();
	}

	private SortDescDirection(sortId: any) {
		this.data.data = this.data.data.slice().sort((a, b) => a[sortId] < b[sortId] ? -1 : a[sortId] < b[sortId] ? 1 : 0,);
  	}
  
  	Approve(row: any) {
		this.buttonApprove.emit(this.selectedRow);
  	}

	Reject(row: any) {
		this.buttonReject.emit(this.selectedRow);
	}

	RedirectToSubscontrating(row: any) {
		this.buttonRedirectToSubcontracting.emit(this.selectedRow);
	}

  	ChangeSelect(row: any) {
		this.selectedRow=row;
		if (this.selectedRow == null || this.selectedRow == undefined) {
			this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: this.translateService.data.TABLE.SELECT_ROW,
			shown: true
      	});
      	return;
		}
		this.buttonChangeStatus.emit(this.selectedRow);
	}

	ShowApprovalHistory(row: any) {
		this.selectedRow = row;
		if (this.selectedRow == null || this.selectedRow == undefined) {
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Error',
				message: this.translateService.data.TABLE.SELECT_ROW,
				shown: true,
			});
			return;
		}
		this.buttonShowApprovalHistory.emit(this.selectedRow);
	}
}
